import type { ReactElement } from "react";

import type { EnrichedContentJsonObject, ErrorJsonObject } from "../types/content";

import {
    createSignalsFiltersComponent,
    createExistingFilterSetComponent,
    createFiltersComponent,
    createCraftedSignalComponent,
    createSuggestedQueriesComponent,
    createCustomErrorComponent,
    type IComponentFactoryContext,
} from "./componentFactories";

export const getComponentForJsonObject = (
    jsonObj: EnrichedContentJsonObject | ErrorJsonObject,
    keyIdentifier: string | number,
    context: IComponentFactoryContext,
): ReactElement | null => {
    const { name } = jsonObj;

    switch (name) {
        case "SignalsFiltersWereAdded":
        case "SignalsFiltersWereModified":
        case "SignalsFiltersWereRemoved": {
            return createSignalsFiltersComponent(jsonObj, keyIdentifier, context);
        }

        case "ExistingFilterSet": {
            return createExistingFilterSetComponent(jsonObj, keyIdentifier, context);
        }

        case "FiltersWereAdded":
        case "FiltersWereRemoved":
        case "FiltersWereModified": {
            return createFiltersComponent(jsonObj, keyIdentifier, context);
        }

        case "CraftedSignal": {
            return createCraftedSignalComponent(jsonObj, keyIdentifier, context);
        }

        case "SuggestedQueries": {
            return createSuggestedQueriesComponent(jsonObj, keyIdentifier, context);
        }

        case "CustomError": {
            return createCustomErrorComponent(jsonObj, keyIdentifier, context);
        }

        case "ContextualSuggestions":
        case "OutputFilters": {
            // Command-only, don't render anything
            return null;
        }

        default: {
            throw new Error(`Unexpected value: ${name as string}`);
        }
    }
};
